




















































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import {
  timeFormat,
} from "@/utils";
@Component({
  name: "AppliedIndex",
})
export default class AppliedIndex extends Vue {
  @Provide() private detailList: Array<Object> = [];
  @Provide() private dialogVisible: Boolean = false;
  @Provide() private tableLoading: Boolean = false;
  @Prop() orderId: any;
  @Prop() reduceId: any;

  //get reduce list
  private async getReduceDetailList() {
    this.tableLoading = true;
    const { setGetReduceAuditDetailReq, getReduceDetailsRequest }: any =
      await import("@/request/getReduceList");
    let data = await getReduceDetailsRequest.handleHttp(
      setGetReduceAuditDetailReq({
        OrderId: this.orderId,
        reduceId: this.reduceId,
      }),
      null
    );
    if (data && data.auditlistList) {
      this.detailList = data.auditlistList.map((item: any) =>
        Object.assign({}, item, {
          time: item.time ? timeFormat(item.time) : "-",
          audittime: item.audittime ? timeFormat(item.audittime) : "-",
        })
      );
    } else {
      this.detailList = [];
    }
    this.tableLoading = false;
  }
  private handleDialog() {
    this.dialogVisible = true;
    this.getReduceDetailList();
  }
  private handleClose() {
    this.dialogVisible = false;
    this.detailList = [];
  }
}
